// extracted by mini-css-extract-plugin
export default {"icon":"src-signer-app-icons-icon-module__icon--1aWX-"};